module.exports = __webpack_public_path__ + "static/img/tc05.1e7024f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/tc05.png
// module id = 174
// module chunks = 0